export default __webpack_public_path__ + "static/media/bg_1.a8b0afb2.png";